import React, { Component } from 'react';
// import { View, Image, StyleSheet, StatusBar, Keyboard, Linking,
//    TouchableOpacity, KeyboardAvoidingView, Platform,  ScrollView, Dimensions, Share, BackHandler, Alert, ImageBackground, TouchableHighlight, 
//    PermissionsAndroid, TouchableWithoutFeedback } from 'react-native';
import AsyncStorage from '@react-native-community/async-storage';
import { connect } from 'react-redux';
import { login, dispatchClearLoginInfo, } from './../../store/actions';
import Toaster from './../../components/snackBar_toaster';
// import { Text, Styles} from './../../components/UI-Components';
import './login.scss';
import { FaPhoneAlt } from 'react-icons/fa'
import TextField from '@material-ui/core/TextField';
import { Button } from './../../components'
import logo from './../../assets/images/logo.png';
// const isIos = Platform.OS === "ios";


// const logo = require('./../../assets/logo1.png')

class Login extends Component {




  constructor(props) {
    super(props);
    this.state = {
      mobile: "",
      numberValidate: true,
      error: false,
      props: this.props,
      theme: this.props.theme || null,
      visible: false,
      snackbarMsg: null,
      userInfo: null,
      showToast: false,
      toasterMessage: '',
      buttonDisable: false
    }
  }



  showToaster = (msg) => {
    this.setState({
      showToast: true,
      toasterMessage: msg
    })
  }




  clearAllDataAndLogout = () => {
    // this.props.dispatchClearRegistation();  
  }

  async componentDidMount() {
    // firebaseLogEvent('login_screen', {})
    AsyncStorage.getItem('authKey', (err, res) => {
      // console.log(res)
      if (res) {
        // this.props.history.push('/Home')
        this.clearAllDataAndLogout();
      }
    })
  }


  componentWillUnmount() {
    // this.props.dispatchClearLoginInfo();
  }

  componentDidUpdate(prevProps) {
    if (this.props.err !== prevProps.err) {
      if (this.props.err) {
        this.showToaster(this.props.errInfo)
      }
    }

    if (this.props.status !== prevProps.status) {
      const toastMsg = typeof this.props.successInfo === 'string' ? this.props.successInfo : 'OTP successfully sent';

      if (this.props.status === 200) {
        if (this.props.status) {
          this.setState({
            buttonDisable: true
          })
          this.showToaster(toastMsg);
          setTimeout(() => {
            this.props.history.push(`/OtpScreen/${this.state.mobile}`);
            // this.setState({ mobile: '' , buttonDisable: false})
          }, 1000)
        }
      }
    }

  }




  validatePhone = () => {

    if (/^([0|\+[0-9]{1,5})?([6-9][0-9]{9})$/.test(this.state.mobile)) {
      // this.props.navigation.navigate('OtpScreen');
      this.setState({ error: false });
      this.props.login(this.state.mobile);
    } else {
      this.setState({
        error: true
      })
    }
  };

  // share = () => {
  //   Share.share({
  //     title: '2thepoint',
  //     url: 'www.2thepoint.in',
  //     message: 'https://www.2thepoint.in'
  //   },
  //     {
  //       dialogTitle: 'share this page'
  //     })
  // }
  render() {
    const { error, snackbarMsg } = this.state;
    const { err, errInfo, loading, response } = this.props;
    return (

      <div className='login_main'>
        <div className='login_box'>
          <>
            <span class="h1" style={{ fontWeight: 'bold', marginTop: 20 }}>
              Welcome
                            </span>
            <div className='mt-4 mb-4 py-4' style={{ marginTop: 20 }}>
              <img src={logo} className='logo' />
            </div>
            <div style={{ height: 200, width: '80%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                width: '100%',
              }}>
                <FaPhoneAlt size={20} color={'grey'} style={{ marginTop: 20, marginRight: 20 }} />
                <TextField
                  inputProps={{ maxLength: 10 }}
                  id="standard-number"
                  style={{ width: '100%' }}
                  value={this.state.mobile}
                  onChange={e => {
                    const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                    if (onlyNums.length < 10) {
                      this.setState({ mobile: onlyNums });
                    } else if (onlyNums.length === 10) {
                      const number = onlyNums.replace(
                        /(\d{3})(\d{3})(\d{4})/,
                        '$1$2$3'
                      );
                      this.setState({ mobile: number });
                    }

                  }
                  }
                  label="Mobile"
                  onKeyPress={({ nativeEvent: { key: keyValue } }) => {
                    if (keyValue === 'Enter') {

                      this.validatePhone()
                    }
                  }}

                />
              </div>
              <div style={{ marginTop: 10, width: '80%' }}>
                <span style={{ color: 'red', alignSelf: 'flex-end', fontSize: 11, marginRight: '1%' }}>{error && "Enter valid mobile number"}</span>
              </div>
              <div style={{ width: '80%', marginTop: 30, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                <Button
                  width={'100%'}
                  height={50}
                  bgColor={'#FF7954'}
                  bdColor={'#FF7954'}
                  title={'Login'}
                  textStyle={{ color: '#fff', fontWeight: '700', fontSize: 20 }}
                  onClick={() => this.validatePhone()}

                />
              </div>
            </div>
          </>

          {/* <Image source={logo} style={{width: 200, height: 50,  marginBottom: 20 }} resizeMode='contain'  />
              <View style={{}}>
                <Text style={{ fontSize: 20, marginBottom: 0 }}>
                  Sign in
                  </Text>
              </View> */}

          {/* <View style={{ marginTop: 15,  width: '80%' }}>
                <Text style={{ color: 'red', alignSelf: 'flex-end', fontSize: 11, marginRight: '1%' }}>{error && "Enter valid mobile number"}</Text>
              </View> */}

          {/* <View style={{ width: '100%', marginTop: 10}}>
             
                <TextInput
                  mode="outlined"
                  style={[styles.inputBox]}
                  label='Mobile'
                  value={this.state.mobile}
                  isFocused={false}
                  keyboardType='numeric'
                  error={this.state.error}
                  onChangeText={mobile => {
                    if(mobile.length > 10 ) return null;
                    this.setState({ mobile })}
                  }
                  underlineColor={'#A4A4A4'}
                  maxLength={10}
                  theme={{ colors: { placeholder: '#A4A4A4', text: 'rgba(0,0,0,0.7)', primary: '#A4A4A4', underlineColor: '#A4A4A4', } }}
                  onKeyPress={({nativeEvent: { key: keyValue }}) =>{
                    if(keyValue === 'Enter'){
               
                      this.validatePhone()
                    }
                  } }
               />

              </View> */}


          {/* <View style={{ width: 220, marginBottom: 15, marginTop: 45 }}>
                <Button
                  onPress={() => this.validatePhone()}
                  mode="contained"
                  style={styles.button}
                  disabled={this.props.loading || this.state.buttonDisable ? true : false}
                  uppercase={false}
                  loading={this.props.loading  ? true : false}
                >
                  <Text style={{ fontSize: 16, fontWeight: '400' }}> Login now</Text>
                </Button>
              </View> */}

          {/* <View style={{ marginTop: 15, marginBottom: 15 }}>
                <Text style={{ color: '#455A64' }}>
                  Don't have an account ?
                <Text
                    style={{ color: Styles.primaryColor, fontSize: 15, fontWeight: '500', cursor: 'pointer' }}
                    onPress={() => {
                      this.props.history.push('/Register')
                      this.setState({ mobile: '' });
                    }
                    }
                  // onPress={() => this.props.navigation.navigate('OtpScreen')}
                  > Sign Up
            </Text>
                </Text>
              </View> */}

        </div>

        <Toaster
          show={this.state.showToast}
          message={this.state.toasterMessage}
        />
      </div>

    )
  }
}

// const styles = StyleSheet.create({
//   statuBarColor: {
//     // backgroundColor: Colors.statuBarColor,
//   },
//   splashBackgroundImage: {
//     width: '100%',
//     height: '100%',
//   },
//   container: {
//     alignItems: 'center',
//     justifyContent: 'center',
//     paddingHorizontal: 10,
//     width: 400,
//     // height: deviceHeight
//   },
//   inputBox: {
//     // width: '70%',
//     // backgroundColor: 'transparent',
//   },

//   button: {
//     borderRadius: 10,
//     backgroundColor: Styles.primaryColor,
//     borderRadius: 25,
//   },
//   fbBtnn: {
//     width: '100%',
//     backgroundColor: '#BF360C',
//     marginVertical: 10,
//   },
//   buttonText: {
//     fontSize: 14,
//     color: '#fff',
//     textAlign: 'center'
//   },
//   forgetText: {
//     color: '#263238',
//     fontSize: 16,
//     fontWeight: '500',
//     marginTop: 40,
//     justifyContent: 'center',
//     fontWeight: '600',
//     color: '#000'
//   },
//   _bottomText: {
//     marginTop: 'auto',
//     color: '#fff',
//     fontSize: 16,
//     marginBottom: 10
//   },
//   get bottomText() {
//     return this._bottomText;
//   },
//   set bottomText(value) {
//     this._bottomText = value;
//   },
//   signupText: {
//     fontSize: 16,
//     marginLeft: 25,
//     ...Platform.select({
//       android: {
//         color: '#fff',
//         fontWeight: '700'
//       },
//       ios: {
//         color: '#1a2b63',
//       }
//     })
//   },
//   error: {
//     borderColor: '#fff',
//     borderWidth: 1
//   },
//   searchSection: {
//     flexDirection: 'row',
//     justifyContent: 'center',
//     alignItems: 'center',
//     marginTop: 10
//   },
//   searchIcon: {
//     position: 'absolute',
//     right: 15,
//     top: 18,
//     color: 'rgba(0,0,0,0.6)',
//     // marginLeft: 15

//   },
//   SocialIcon: {
//     flexDirection: 'row',
//     width: 300,
//     justifyContent: 'space-around',
//     marginVertical: 25
//   },
//   facebookIcon: {
//     flex: 1,
//     borderRadius: 0,
//     color: '#3C5A99'
//   },
//   googleIcon: {
//     flex: 1,
//     color: '#222'
//   },
//   ptfrm_text: {
//     ...Platform.select({
//       android: {
//         paddingBottom: 5,
//         color: '#fff'
//       },
//       ios: {
//         paddingBottom: 5,
//         color: '#fff'

//       }
//     })
//   }
// })

const mapStateToProps = state => ({
  loading: state.login && state.login.loading,
  response: state.login.response && state.login.response,
  status: state.login.response && state.login.response && state.login.response.status,
  successInfo: state.login.response && state.login.response.data && state.login.response.data.message && state.login.response.data.message,
  err: state.login && state.login.err,
  errInfo: state.login && state.login.errInfo && state.login.errInfo.response && state.login.errInfo.response.data && state.login.errInfo.response.data.message && state.login.errInfo.response.data.message
})

export default connect(mapStateToProps, {
  login, dispatchClearLoginInfo,

})(Login);

// export default Login
